var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1126_24978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6667,
    y: 20.667,
    width: 20.6667,
    height: 20.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0302 49.3101L22.4902 49.1242C19.4013 49.0594 16.3048 49.1887 13.2765 48.5178C8.66984 47.5153 8.34348 42.6 8.00198 38.477C7.53144 32.6806 7.7136 26.779 8.60158 21.031C9.10288 17.8058 11.0757 15.8812 14.1266 15.6718C24.4255 14.9118 34.7929 15.0019 45.069 15.3564C46.1543 15.3889 47.247 15.5666 48.3172 15.7688C53.5997 16.7552 53.7285 22.3253 54.0709 27.0143C54.4124 31.7516 54.2682 36.5133 53.6155 41.2184C53.0918 45.1141 52.0899 48.3811 47.8618 48.6964C42.5642 49.1088 37.3881 49.4408 32.0756 49.3351C32.0758 49.3101 32.0453 49.3101 32.0302 49.3101ZM26.4216 39.4472C30.4138 37.0056 34.3298 34.6047 38.2992 32.1794C34.2995 29.7378 30.391 27.3368 26.4216 24.9116V39.4472Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1126_24978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "white",
    transform: "translate(7.75 7.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.1b21ca8f78263fa535ed37e2e384ae41.svg";
export { ForwardRef as ReactComponent };